/**
 * Ordering for filter dropdowns — composite slugs grouped after individual key stages.
 * Used by sortKeyStageOptions.
 */
export const KEY_STAGE_FILTER_ORDER: readonly string[] = [
  "eyfs",
  "en-gb-key-stage-1",
  "en-gb-key-stage-2",
  "en-gb-key-stage-lower-2",
  "en-gb-key-stage-upper-2",
  "en-gb-key-stage-1-and-2",
  "nursery",
  "reception",
  "year-1",
  "year-2",
  "year-3",
  "year-4",
  "year-5",
  "year-6",
];

/**
 * Pedagogical ordering for the unit drawer — interleaves key stages with their
 * constituent year groups so resources sort in the order a teacher would expect.
 * Intentionally differs from KEY_STAGE_FILTER_ORDER; slugs not listed here
 * (including broad KS2 and composite spans like en-gb-key-stage-1-and-2)
 * sort to the end (Infinity).
 */
export const KEY_STAGE_SORT_ORDER: readonly string[] = [
  "eyfs",
  "nursery",
  "reception",
  "en-gb-key-stage-1",
  "year-1",
  "year-2",
  "en-gb-key-stage-lower-2",
  "year-3",
  "year-4",
  "en-gb-key-stage-upper-2",
  "year-5",
  "year-6",
];

/**
 * Slugs that fall outside the broad "key stage" groupings — includes EYFS,
 * nursery, reception, and individual year groups. Used as a tiebreaker when a
 * resource is tagged with both a key stage and a more specific year/phase.
 */
export const YEAR_ONLY_SLUGS: ReadonlySet<string> = new Set(
  KEY_STAGE_SORT_ORDER.filter((s) => !s.startsWith("en-gb-key-stage")),
);
